@if (country(); as countryValue) {
    <div>
        <div class="tab__title">{{ 'countryInfo' | translate }}</div>
        <div class="detail-container">
            <div>
                <div class="label">{{ 'countrydetails.countryISO' | translate }}</div>
                <div>{{ countryValue.isoName }}</div>
            </div>
            <div>
                <div class="label">{{ 'countrydetails.timezone' | translate }}</div>
                <div>{{ countryValue.timeZone?.name }}</div>
            </div>
            <div>
                <div class="label">{{ 'countrydetails.countryISO2' | translate }}</div>
                <div>{{ countryValue.isoCode2 }}</div>
            </div>
            <div>
                <div class="label">{{ 'countrydetails.countryISO3' | translate }}</div>
                <div>{{ countryValue.isoCode3 }}</div>
            </div>
            <div>
                <div class="label">UTC</div>
                <div>{{ countryValue.timeZone?.standardOffset }}</div>
            </div>
            <div>
                <div class="label">{{ 'countrydetails.utcSummertime' | translate }}</div>
                <div>{{ countryValue.timeZone?.summerTimeOffset }}</div>
                @if (countryValue.timeZone?.summerBeginDate) {
                    <div>
                        {{ countryValue.timeZone?.summerBeginDate | date: 'dd.MM.yyyy' }} -
                        {{ countryValue.timeZone?.winterBeginDate | date: 'dd.MM.yyyy' }}
                    </div>
                }
            </div>
            <div>
                <div class="label">{{ 'countrydetails.numcodesiemens' | translate }}</div>
                <div>{{ countryValue.siemensCode }}</div>
            </div>
        </div>
        <div class="divider"></div>
        <div class="detail-container">
            <div>
                <div class="label">{{ 'countrydetails.region' | translate }}</div>
                <div>{{ countryValue.region }}</div>
            </div>
            <div>
                <div class="label">{{ 'countrydetails.continent' | translate }}</div>
                <div>{{ countryValue.continent }}</div>
            </div>
            <div>
                <div class="label">{{ 'countrydetails.cluster' | translate }}</div>
                <div>{{ countryValue.cluster }}</div>
            </div>
            <div>
                <div class="label">{{ 'countrydetails.currency' | translate }}</div>
                <div>{{ countryValue.currency?.name }} - {{ countryValue.currency?.code }}</div>
            </div>
            <div class="full-width">
                <div class="label">{{ 'countrydetails.urlCountry' | translate }}</div>
                <div>{{ countryValue.url }}</div>
            </div>
        </div>
        <div class="divider"></div>
        <div class="detail-container">
            <div class="full-width">
                <div class="label">{{ 'countrydetails.plzLaunch' | translate }}</div>
                <div>{{ countryValue.postcodeSystem?.launchedDate }}</div>
            </div>
            <div class="full-width">
                <div class="label">{{ 'countrydetails.plzForm' | translate }}</div>
                <div>{{ countryValue.postcodeSystem?.format }}</div>
            </div>
            <div class="full-width">
                <div class="label">{{ 'countrydetails.plzExample' | translate }}</div>
                <div>{{ countryValue.postcodeSystem?.example }}</div>
            </div>
            <div class="full-width">
                <div class="label">{{ 'countrydetails.plzInfo' | translate }}</div>
                <div>{{ countryValue.postcodeSystem?.info }}</div>
            </div>
            <div class="full-width">
                <div class="label">{{ 'countrydetails.plzInfoDate' | translate }}</div>
                <div>{{ countryValue.postcodeSystem?.infoLastUpdated }}</div>
            </div>
        </div>
        <div class="divider"></div>
        <div class="detail-container">
            <div>
                <div class="label">{{ 'countrydetails.workingHourWeek' | translate }}</div>
                <div>{{ countryValue.workingHours?.weekPattern }}</div>
            </div>
            <div>
                <div class="label">{{ 'countrydetails.workingHourWeekHours' | translate }}</div>
                <div>{{ countryValue.workingHours?.weeklyHours }}</div>
            </div>
            <div>
                <div class="label">{{ 'countrydetails.workingHourDay' | translate }}</div>
                <div>{{ countryValue.workingHours?.dailyHours }}</div>
            </div>
            <div class="full-width">
                <div class="label">{{ 'countrydetails.workingHourComment' | translate }}</div>
                <div>{{ countryValue.workingHours?.comment }}</div>
            </div>
        </div>
        <div class="divider"></div>
        <div class="detail-container">
            <div class="full-width">
                <div class="label">{{ 'countrydetails.holidays' | translate }}</div>
                @for (holiday of holidays(); track holiday.date) {
                    <div>{{ holiday.date | date: 'dd.MM.yyyy' }} - {{ holiday.title }}</div>
                }
            </div>
        </div>
    </div>
}
